module.exports = __webpack_public_path__ + "static/media/Toby.7723fcc2.png";